<template>
  <div class="text-left">
    <h5>
      <span v-text="t('forms.login_cred.IC_0010')"/>
      <i
        class="fa fa-question-circle"
        @click="showModal = true"/>
    </h5>
    <hr>

    <label class="bottomMargin">
      <span v-text="t('forms.add_a_contractor.IC_0018')"/>
      <span class="required">*</span>
      <i
        class="fa fa-question-circle"
        @click="showEmailModal = true"/>
      <a
        href="/forgot.php"
        target="_blank"
        v-text="t('auth.forgot_password')"/>
      <input
        v-model="adminInfo.email"
        :placeholder="t('register.enter_email')"
        type="text"
        class="no-margin"
        maxlength="100">
      <small
        v-if="emailError && displayError"
        class="error"
        v-text="t('member_basic_edit.IC_0037')"/>
    </label>

    <div>
      <span v-text="t('password_change.password_new_must')" />
      <ul>
        <li v-html="t('password_change.password_length')"/>
        <li v-html="t('password_change.password_uppercase')"/>
        <li v-html="t('password_change.password_number')"/>
        <li v-html="t('password_change.password_common')"/>
        <li v-html="t('password_change.password_constitutive_characters')"/>
      </ul>
    </div>

    <label class="bottomMargin">
      <span v-text="t('forms.login_cred.IC_0004')"/>
      <span class="required">*</span>
      <input
        v-model="adminInfo.password"
        :placeholder="t('register.enter_password')"
        type="password"
        autocomplete="off"
        class="no-margin">
      <small
        v-if="passwordError && displayError"
        class="error"
        v-text="t('eInvoicing.password_meet_requirements')"/>
    </label>

    <label class="bottomMargin">
      <span v-text="t('forms.login_cred.IC_0006')"/>
      <span class="required">*</span>
      <input
        v-model="adminInfo.passwordMatch"
        :placeholder="t('register.re_enter_password')"
        type="password"
        autocomplete="off"
        class="no-margin">
      <small
        v-if="passwordMatchError && displayError"
        class="error"
        v-text="t('xajax.newcontractor.server.IC_0014')"/>
    </label>

    <label class="bottomMargin">
      <span v-text="`${t('forms.login_cred.IC_0007')} ${t('forms.login_cred.IC_0008')}`"/>
      <span class="required">*</span>
      <i
        class="fa fa-question-circle"
        @click="showCaptchaModal = true"/>
      <div>
        <img
          :src="captchaSource"
          alt="CAPTCHA"
          width="84"
          height="27"
          style="margin-bottom: 20px;">
        <i
          class="fa fa-refresh"
          style="font-size: 20px;"
          @click="resetCaptcha"/>
      </div>
      <input
        v-model="adminInfo.captcha"
        type="text"
        class="no-margin"
        maxlength="4">
      <small
        v-if="captchaError && displayError"
        class="error"
        v-text="t('xajax.newcontractor.server.IC_0034')"/>
    </label>

    <div class="row">
      <div class="columns large-4">
        &nbsp;
      </div>
      <div class="columns large-4">
        <button
          @click="openGuide"
          class="tiny radius expand"
          v-text="t('register.user_guide')"/>
      </div>
      <div class="columns large-1">
        &nbsp;
      </div>
      <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="saveAdminContact"
            v-text="t('member_basic_edit.IC_0013')"/>
      </div>
    </div>

    <modal
      v-if="showModal"
      :size="`small`"
      :show-close-button="true"
      @close="showModal = false">
      <p
        class="modalMargin"
        v-html="`${t('forms.login_cred.IC_0000')} ${t('forms.login_cred.IC_0001')}`"/>
    </modal>

    <modal
      v-if="showEmailModal"
      :show-close-button="true"
      @close="showEmailModal = false">
      <p>
        <email/>
      </p>
    </modal>

    <modal
      v-if="showCaptchaModal"
      :size="`small`"
      :show-close-button="true"
      @close="showCaptchaModal = false">
      <p v-html="captchaHtml"/>
    </modal>
  </div>

</template>

<script>
import $      from 'jquery';
import _      from 'lodash';
import toastr from 'toastr';
import Modal  from '../../Ui/Modal.vue';
import Email  from '../HelpModals/Email.vue';

export default {

  components: {
    Modal,
    Email,
  },

  props: ['displayData'],

  data() {
    return {
      showModal: false,
      showEmailModal: false,
      showCaptchaModal: false,
      captchaHtml: '',
      localData: {},
      displayError: false,
      commonPassword: [
        'Password123',
        'Safety2014',
        'Safety2015',
        'Safety2016',
        'Safety2017',
      ],
      adminInfo: {
        email: '',
        password: '',
        passwordMatch: '',
        captcha: '',
      },
      captchaError: true,
    };
  },

  computed: {
    captchaSource() {
      return `data:image/png;base64,${this.displayData.captchaInfo.image}`;
    },

    emailError() {
      return _.isEmpty(this.adminInfo.email) || !this.validateEmail(this.adminInfo.email);
    },

    passwordError() {
      return _.isEmpty(this.adminInfo.password) || !this.validatePassword(this.adminInfo.password);
    },

    passwordMatchError() {
      return _.isEmpty(this.adminInfo.password) ||
        this.adminInfo.password !== this.adminInfo.passwordMatch;
    },
  },

  mounted() {
    $.get('/information.php?t=captcha', (data) => { this.captchaHtml = data; return false; });

    this.localData = _.cloneDeep(this.displayData);
  },

  methods: {
    openGuide() {
      window.open(t('register.user_guide_link'), '_blank')
    },

    saveAdminContact() {
      this.displayError = true;
      this.captchaError = false;

      if (this.emailError || this.passwordError || this.passwordMatchError) {
        return false;
      }

      $.post('/register/password-check', {
        captcha: this.adminInfo.captcha,
        email: this.adminInfo.email,
        password: this.adminInfo.password,
      }, (data) => {
        if (data.error !== false) {
          if (data.reason) {
            toastr.error(data.reason);
          }

          if (data.error === 'password') {
            this.reset();
          }

          if (data.error === 'captcha') {
            this.captchaError = true;
          }
        } else {
          this.localData.adminInfo = data.adminInfo;
          this.localData.adminInfo.PasswordEnter = this.adminInfo.password;
          this.$emit('display-change', this.localData);
          this.$emit('tab-change', 1);
        }
      });

      return false;
    },

    resetCaptcha() {
      $.post('/register/reset-captcha', {}, (data) => {
        this.localData.captchaInfo = data;
        this.captchaError = true;
        this.$emit('display-change', this.localData);
      });
    },

    reset() {
      this.resetCaptcha();

      this.adminInfo.password = '';
      this.adminInfo.passwordMatch = '';
      this.adminInfo.captcha = '';
      this.displayError = false;
    },

    validateEmail(email) {
      const emailValidator = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return emailValidator.test(email);
    },

    validatePassword(password) {
      const rules = [
        /^.{0,7}$/, // shorter than 8 characters
        /^((?![0-9]).)*$/, // does not contain a number
        /^((?![A-Z]).)*$/, // does not contain an upper case letter
        /(.)\1{4}/, // contains more than 4 consecutive characters
      ];

      const passesRules = rules.filter(rule => rule.test(password)).length === 0;

      return passesRules && !_.includes(this.commonPassword, password);
    },
  },
};
</script>
